import { Component, Prop, h, Watch, State, Element } from '@stencil/core';
import { Close } from '../../icons/index';
import { isRtl } from '@ugc-utils/utils';
import state from '@ugc-store';

@Component({
  tag: 'ugc-drawer',
  styleUrl: 'ugc-drawer.scss',
  shadow: false,
})
export class UgcDrawer {
  @Prop() isShow: boolean = false;
  @Prop() isConfirm: boolean = false;
  @Prop() isShowButton: boolean = true;
  @Prop() isShowCloseButton: boolean = true;
  @Prop() modalTitle: string = '';
  @Prop() submitButtonText: string = 'Submit';
  @Prop() type: string = 'primary';
  @Prop() disabled: boolean = false;
  @Prop() disabledBackDropClick: boolean = false;
  @Prop() zIndex: number = 9999;
  @Prop() isGray: boolean = false;
  @Prop() handleSubmit: () => void;
  @Prop() handleCancel: () => void;
  @Prop() handleScroll: () => void;

  @State() active: boolean = false;
  @State() animateClass: string = '';

  @Element() hostElement: HTMLElement;

  timer: number;

  @Watch('isShow')
  watchShowValue(newValue) {
    if (newValue) {
      this.disableScroll();
      this.active = true;
      this.animateClass = 'enter';
      setTimeout(() => {
        this.animateClass = 'enter-active';
      });
    } else {
      this.enableScroll();
      this.animateClass = 'exit';
      setTimeout(() => {
        this.animateClass = 'exit-active';
      });
    }
  }

  disableScroll = () => {
    try {
      if (this.isShow) {
        const htmlEl = document.querySelector('html');
        htmlEl.setAttribute('style', 'overflow:hidden');
      }
    } catch (e) {}
  };

  enableScroll = () => {
    try {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }

      this.timer = window.setTimeout(() => {
        const allDrawers = document.querySelectorAll('ugc-drawer');

        let hasOtherActiveDrawers = false;

        for (let i = 0; i < allDrawers.length; i++) {
          const drawer = allDrawers[i];
          if (drawer !== this.hostElement && drawer.isShow === true) {
            hasOtherActiveDrawers = true;
            break;
          }
        }

        if (hasOtherActiveDrawers) {
          return;
        }

        const htmlEl = document.querySelector('html');
        if (htmlEl && htmlEl.style.overflow === 'hidden') {
          htmlEl.removeAttribute('style');
        }
      }, 100);
    } catch (e) {
      console.error('Error in enableScroll:', e);
    }
  };

  handleClickMantle = () => {
    if (this.disabledBackDropClick) return;
    this.handleCancel();
  };

  onTransitionEnd = () => {
    this.animateClass = this.isShow ? `enter-done` : 'exit-done';
    if (!this.isShow) {
      this.active = false;
    }
  };

  renderButton() {
    if (!this.isShowButton) return;

    const {
      qnaStaticLanguage: { IDS_UGC_QNA_MODAL_APPLY = '', IDS_UGC_QNA_MODAL_CANCEL = '' },
      isDesktop,
    } = state;

    const buttonStyle = isRtl() ? { margin: '0 0 0 8px' } : { margin: '0 8px 0 0' };
    return this.isConfirm ? (
      <div class="modal-button-wrap flex-row-between-center">
        <ugc-button
          type="ghost"
          disabled={this.disabled}
          height="48"
          fontWeight="bold"
          onClick={this.handleCancel}
          style={{ flex: '1', ...buttonStyle }}
          data-testid="cancel"
        >
          {IDS_UGC_QNA_MODAL_CANCEL}
        </ugc-button>
        <ugc-button
          type="primary"
          disabled={this.disabled}
          height="48"
          fontWeight="bold"
          onClick={this.handleSubmit}
          style={{ flex: '1' }}
          data-testid="apply"
        >
          {IDS_UGC_QNA_MODAL_APPLY}
        </ugc-button>
      </div>
    ) : (
      <div
        class="modal-button-wrap"
        style={isDesktop && { borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}
      >
        <ugc-button type={this.type} disabled={this.disabled} height="48" fontWeight="bold" onClick={this.handleSubmit}>
          {this.submitButtonText}
        </ugc-button>
      </div>
    );
  }

  render() {
    if (!this.isShow && !this.active) {
      return null;
    }

    const { isDesktop } = state;
    // style
    const modalWrapStyle: any = {};
    const renderModalContentWrapStyle: any = this.isShowButton ? { paddingBottom: '80px' } : {};
    const isGrayModal = this.isGray ? { backgroundColor: '#f5f5f5' } : {};

    if (this.zIndex !== 0) {
      modalWrapStyle.zIndex = `${this.zIndex}`;
      renderModalContentWrapStyle.zIndex = `${this.zIndex + 1}`;
    }

    return (
      <div class="modal-wrap" style={modalWrapStyle} role="drawer" onTransitionEnd={this.onTransitionEnd}>
        <div class={{ 'modal-mantle': true, [this.animateClass]: true }} onClick={this.handleClickMantle} />
        <div
          class={{
            'modal-content-wrap': true,
            'modal-content-desktop-wrap': isDesktop,
            'modal-content-mobile-wrap': !isDesktop,
            [this.animateClass]: true,
          }}
          style={{ ...renderModalContentWrapStyle, ...isGrayModal }}
        >
          {this.modalTitle && (
            <div class="py-16 px-24 flex-row-between-center">
              <span class="fs-20 bold c-333">{this.modalTitle}</span>
              {this.isShowCloseButton && (
                <div class="flex-row-end-center pointer" onClick={this.handleCancel.bind(this)}>
                  <Close width="24" height="24" />
                </div>
              )}
            </div>
          )}
          <div class={`modal-content ${!this.modalTitle && 'mt-16'}`} onScroll={this.handleScroll}>
            <slot />
          </div>
          {this.renderButton()}
        </div>
      </div>
    );
  }
}
